<app-back-header 
  [headerText]="'Torna alla dashboard'" 
  (backAction)="backToDashboard()" 
  class="sticky-top">
</app-back-header>

<div class="d-flex justify-content-between align-items-center mb-2">
  <h3 class="ms-2 mt-2">Guide e tutorial</h3>
</div>

<p class="ms-2">In questa pagina trovi tutorial e consigli per usare l'App di {{ sourceLabels[organization_data?.source || ''] || 'fatturazione' }} nel migliore dei modi.</p>

<ng-container *ngIf="isLoading">
  <div class="loading-container d-flex flex-column justify-content-center align-items-center py-5">
    <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
    <p class="mt-3">Caricamento in corso...</p>
  </div>
</ng-container>

<div>
  <div class="row g-3">
    
    <div class="col-12 col-md-4" *ngFor="let guide of tutorials">
      
      <mat-card class="h-100 custom-card">
        <mat-card-header>
          <mat-card-title>{{guide.id}} - {{ guide.title }}</mat-card-title>
          <mat-card-subtitle class="mt-2">{{ guide.subtitle }}</mat-card-subtitle>
        </mat-card-header>
        
        <mat-card-content>
          <p class="mt-2">
            {{ guide.content }}
          </p>
        </mat-card-content>
        
        <mat-card-actions align="end">
          <button mat-button (click)="handleGuideClick(guide.id)">Apri scheda</button>
        </mat-card-actions>
      </mat-card>

    </div>

  </div>
  
</div>

<div class="pt-4 mb-3"></div>

